// extracted by mini-css-extract-plugin
export default {"service-provided-list-container":"InboundCustomerInvoice_service-provided-list-container__YD0x5","prefix-label":"InboundCustomerInvoice_prefix-label__-xSJB"};